module.exports = __webpack_public_path__ + "img/FaceAI4.58c52c12.jpg";